import { type FC } from 'react';

import { type IconProps } from './types';

export const ArrowsPayments3V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 35V65H31" stroke="#FFDD00" strokeWidth="2" />
      <path d="M65 31V1H35" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
